import { render } from "./manage-story.vue?vue&type=template&id=bdba1740"
import script from "./manage-story.vue?vue&type=script&lang=js"
export * from "./manage-story.vue?vue&type=script&lang=js"

import "./manage-story.vue?vue&type=style&index=0&id=bdba1740&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__